export default __webpack_public_path__ + "static/media/type_13_1.3e395ce3.svg";